import s from "./subtitle.module.scss";
import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { CustomEase } from "gsap/CustomEase";
import { useTranslation } from "react-i18next";

export const Subtitle = ({ children, size, skills }) => {
  const { t } = useTranslation();
  gsap.registerPlugin(CustomEase);
  const title = useRef();
  useEffect(() => {
    let ctx = gsap.context(() => {
      gsap.to(`.${s.skill}`, {
        keyframes: [
          { rotateX: "+=90", duration: 0.1, skewX: 10 },
          { rotateX: "+=90", duration: 0.5, opacity: 1, skewX: 0 },
          {
            rotateX: "+=90",
            duration: 1,
            delay: 1,
            opacity: 0,
            skewX: -10,
            ease: CustomEase.create(
              "custom",
              "M0,0 C0.366,0 0.375,-0.415 0.512,-0.294 0.739,-0.094 1,1 1,1 "
            ),
          },
          { rotateX: "+=90", duration: 0.1, skewX: 0 },
        ],
        repeat: -1,
        stagger: 2.7,
      });
    }, title);
    return () => ctx.revert();
  }, []);
  return (
    <h2 ref={title} style={{ fontSize: size }} className={s.subtitle}>
      {children}&nbsp;
      <span className={s.skills}>
        <span className={s.template}>{t("animation_game")}</span>
        {skills.map((i, d) => (
          <span key={d} className={s.skill}>
            {i}
          </span>
        ))}
      </span>
    </h2>
  );
};
